import React, { createContext, useState, useMemo } from 'react';

export const ItemContext = createContext();

export const ItemProvider = ({ children }) => {
    const [itemId,setItemId]=useState(null);
    const [unitId,setUnitId]=useState(null);

  const value = useMemo(
    () => ({ itemId, setItemId, unitId, setUnitId }),
    [itemId, unitId]
  );

  return (
    <ItemContext.Provider value={value}>
      {children}
    </ItemContext.Provider>
  );
};
